import { Box, CardMedia, Typography, useTheme } from "@mui/material";
import { ProposeItemProps } from "./types";
import ButtonWithIcon from "@/components/UI-Kit/ButtonWithIcon";
import ArrowRightIcon from "@/assets/icons/arrow-long-right.svg?react";

const ProposeItem = ({ imgUrl, title, description, label, href }: ProposeItemProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "start"
      }}
    >
      <Box>
        <CardMedia 
          component="img"
          image={imgUrl}
          alt={title}
          sx={{
            width: "100%",
            height: "auto",
            marginBottom: { xs: "16px", md: "32px" },
            borderRadius: "20px"
          }}
        />
        <Typography
          variant="h4"
          component="p"
          sx={{
            marginBottom: { xs: "8px", md: "16px" }
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            marginBottom: { xs: "16px", md: "32px" },
            maxWidth: { md: "75%", xs: "100%" },
            color: theme.palette.grey[600]
          }}
        >
          {description}
        </Typography>
      </Box>
      <ButtonWithIcon
        label={label}
        IconComponent={ArrowRightIcon}
        isLink
        to={href}
      />
    </Box>
  );
};

export default ProposeItem;